export const CATEGORY_ID = 'G20041009';
export const DIMENSIONABLE = 'dimensionable';
export const DIMENSIONABLE_VALUES = ['sí', 'si'];
export const LARGO = 'largo';
export const ANCHO = 'ancho';

export const VALID_TENANTS = {
  FACL: 'facl',
  FAPE: 'fape',
};

export const EVENT_TYPES = {
  WOOD_CUT_OPTIMIZER: 'journeysWoodCutOptimizer',
};

export const ACTIONS = {
  CLOSE_MODAL: 'closeModal',
  ADD_TO_CART: 'addToCart',
};
